import React, { useEffect, useState } from "react";
//import {
//    Box,
//    Typography,
//    Stack,
//    Card,
//    CardContent,
//    //Button,
//    IconButton,
//} from "@mui/material";
//import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//import { ButtonMain } from './Buttons/ButtonMain';
//import CancelIcon from "@mui/icons-material/Cancel";
//import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "react-router-dom";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";
import ErrorPage from "../ErrorPage";
import Loader from "../Utilities/Loader";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const queryValue = searchParams.get("SessionID");

  // success = false;
  //const navigate = useNavigate
  //const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [failedStatusCount, setFailedStatusCount] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [paymentDate, setPaymentDate] = useState("");

  const goToHomepage = () => {
    //navigate("/friends-and-family");
    window.location.replace("/family-and-friends");
  };

  const handleToContinue = () => {
    goToHomepage();
  };

  const handleTryAgain = () => {
    goToHomepage();
  };

  const getPaymentStatus = () => {
    const req = {
      OrderID: queryValue,
    };

    fetch(
      `${apiBaseURL}/api/FriendAndFamily/PaymentAcknowledgmentForWatchoFF`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(req),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        // console.log("API Response6:", resultInfo);
        //setLoading(false);
        setFirstLoad(false);
        if (resultInfo && resultInfo.resultStatus === "Success") {
          setPaymentDetails(resultInfo.result);
          setPaymentStatus(true);

          const dateString = resultInfo.result.paymentDate;
          const date = new Date(dateString);

          const formattedDate = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }).format(date);
          setPaymentDate(formattedDate);

          setTimeout(() => {
            goToHomepage();
          }, 30000);
        } else if (resultInfo && resultInfo.resultStatus === "Failed") {
          setFailedStatusCount((prv) => prv + 1);
          setPaymentStatus(false);
          //if (failedStatusCount <= 6) {
          //    setTimeout(() => {
          //        getPaymentStatus(searchParams)
          //    }, 10000)
          //}
          setTimeout(() => {
            goToHomepage();
          }, 90000);
        }
      })
      .catch((err) => {
        console.error(
          "Error calling GenerateBulkSubscriptionRequest API:",
          err,
        );

        //setLoading(false);
        //setError(err);
      });
  };

  useEffect(() => {
    if (firstLoad) {
      getPaymentStatus(searchParams);
    }
    if (!paymentStatus && failedStatusCount <= 6) {
      setTimeout(() => {
        getPaymentStatus(searchParams);
      }, 10000);
    }
  }, [failedStatusCount]);

  return (
    <>
      {firstLoad /*<div >loading....</div>*/ ? (
        <Loader showLoading={firstLoad} />
      ) : (
        <div className="containerThankuMain">
          {paymentStatus ? (
            <>
              {paymentDetails ? (
                <div>
                  <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                    <div className="container-fluid mobile-res-clss">
                      <a
                        className="navbar-brand custom-logo"
                        href="https://www.watcho.com/"
                      >
                        <img
                          src="/Images/logo.svg"
                          alt="MyLogo"
                          className="img-fluid clas-of-logo"
                        />
                      </a>
                    </div>
                  </nav>

                  <div className="container my-5">
                    <div className="text-center">
                      <div className="congrats-container-fornew">
                        <div className="check-icon">
                          <img src="/Images/Group 39.png" alt="success" />
                        </div>
                        <h2>Congratulations!</h2>
                        <h3>
                          You have now purchased {paymentDetails.noOfVaucher}{" "}
                          Watcho Vouchers
                        </h3>
                        <p className="text-muted-corporate-voucher">
                          The vouchers are sent to your email address and mobile
                          number.
                        </p>
                        <div className="details-box-detail mx-auto">
                          {/*<div className="detail-item-office">*/}
                          {/*    <span className="detail-label-new">Transaction ID</span>*/}
                          {/*    <span className="detail-value">987676899</span>*/}
                          {/*</div>*/}
                          <div className="detail-item-office">
                            <span className="detail-label-new">Order ID</span>
                            <span className="detail-value">
                              {paymentDetails.orderID}
                            </span>
                          </div>
                          <div className="detail-item-office">
                            <span className="detail-label-new">
                              Amount paid
                            </span>
                            <span className="detail-value">
                              ₹{paymentDetails.amount}
                            </span>
                          </div>
                          <div className="detail-item-office">
                            <span className="detail-label-new">
                              Payment Date
                            </span>
                            <span className="detail-value">{paymentDate}</span>
                          </div>
                        </div>

                        <p className="validity">
                          {paymentDetails.message &&
                          paymentDetails.message.length > 0
                            ? paymentDetails.message
                            : "Validity to redeem code is XX from the date of purchase"}
                        </p>

                        <div className="details-box-detail-buttoning mx-auto">
                          <div className="button-section">
                            {/*<button className="yola-btn invoice-btn">Invoice</button>*/}
                            <button
                              className="yola-btn continue-btn"
                              onClick={() => handleToContinue()}
                            >
                              Continue
                            </button>
                          </div>
                        </div>

                        <p className="redirect-message">
                          You will be redirected to Watcho Home page in 30
                          seconds...
                          <i
                            className="fas fa-times close-icon"
                            onClick={goToHomepage}
                          ></i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ErrorPage />
              )}
            </>
          ) : (
            <div>
              <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                <div className="container-fluid mobile-res-clss">
                  <a
                    className="navbar-brand custom-logo"
                    href="https://www.watcho.com/"
                  >
                    <img
                      src="/Images/logo.svg"
                      alt="My Logo"
                      className="img-fluid clas-of-logo"
                    />
                  </a>
                </div>
              </nav>
              <div className="container my-5">
                <div className="text-center">
                  <div className="congrats-container-img">
                    <div className="check-icon-img">
                      <img src="/Images/error.png" alt="error" />
                    </div>
                    <h2>Oops! Payment Failed</h2>
                    <h3>We are unable to process your payment</h3>
                    <p className="text-muted-corporate ">
                      Any money deducted from your bank account will be refunded
                      within 5-10 business days
                    </p>
                    <br />
                    <div className="details-box-detail-buttoning mx-auto">
                      <div className="button-section">
                        <button
                          className="yola-btn invoice-btn"
                          onClick={() => handleTryAgain()}
                          style={{ width: "50%" }}
                        >
                          Try Again
                        </button>
                      </div>
                    </div>
                    <p className="redirect-message">
                      You will be redirected to Offers page in 30 sec...
                      <i
                        className="fas fa-times close-icon"
                        onClick={goToHomepage}
                      ></i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
